import { useEffect, useState } from "react";
import { Calendar, MapPin, Clock, ChevronRight } from "lucide-react";
import * as moment from "moment";
const getTimeLeft = (expiryDate) => {
  const now = new Date().getTime();
  const expiry = new Date(expiryDate).getTime();
  const diff = expiry - now;

  if (diff <= 0) {
    return null;
  }

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const ProgramTimer = ({ program,setIsModalOpen }) => {
  const [timeLeft, setTimeLeft] = useState(
    getTimeLeft(program.expiryDate)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft(program.expiryDate));
    }, 1000);

    return () => clearInterval(interval);
  }, [program.expiryDate]);

  if (!timeLeft) {
    return (
      <div className="bg-black text-white py-6 text-center">
        <p className="text-lg font-semibold">
          Applications Closed
        </p>
      </div>
    );
  }

  return (
    <section className="bg-black text-white py-12 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

        {/* LEFT CONTENT */}
        <div>
          <h1 className="text-3xl md:text-3xl font-bold mb-4">
            {program.name}
          </h1>

          <p className="text-white/80 mb-6 max-w-xl text-sm md:text-md">
            {program.description}
          </p>

          <div className="space-y-2 text-sm text-white/80">
            <p className="flex items-center gap-2">
              <MapPin size={16} /> {program.venue}
            </p>

            <p className="flex items-center gap-2">
              <Calendar size={16} />
             {moment(program.startDate).format("DD-MM-YYYY")} - {moment(program.endDate).format("DD-MM-YYYY")}
            </p>

            <p className="flex items-center gap-2">
              <Clock size={16} />
              Applications close on{" "}
              {moment(program.expiryDate).format("DD-MM-YYYY")}

            </p>
          </div>
        </div>

        {/* RIGHT TIMER */}
       <div className="flex justify-center md:justify-end">
  <div className="grid grid-cols-4 gap-4 text-center">
    {[
      { label: "Days", value: timeLeft.days },
      { label: "Hours", value: timeLeft.hours },
      { label: "Minutes", value: timeLeft.minutes },
      { label: "Seconds", value: timeLeft.seconds },
    ].map((t, i) => (
      <div
        key={i}
        className="  bg-white text-black
          rounded-xl
          px-3 py-4
          w-[70px]
          flex-shrink-0"
      >
        <p className="text-1xl font-extrabold">{t.value}</p>
      <p className="text-xs uppercase tracking-wide whitespace-nowrap">
  {t.label}
</p>
      </div>
    ))}

    {/* CENTERED BUTTON */}
    <div className="col-span-4 flex justify-center mt-4">
    <button
  onClick={setIsModalOpen}
  className="
    relative overflow-hidden
    inline-flex items-center gap-3
    bg-black text-white
    font-semibold
    py-4 px-10
    rounded-xl
    shadow-[0_0_0_1px_rgba(255,255,255,0.08)]
    hover:shadow-[0_0_20px_rgba(255,255,255,0.25)]
    transition-all duration-300
    group
    w-full justify-center
  "
>
  {/* Sparkle layer */}
  <span
    className="
      pointer-events-none
      absolute inset-0
      bg-[linear-gradient(120deg,transparent,rgba(255,255,255,0.6),transparent)]
      translate-x-[-100%]
      group-hover:translate-x-[100%]
      transition-transform duration-700
    "
  />

  {/* Content */}
  <span className="relative z-10">Apply Now</span>
  <ChevronRight className="relative z-10 w-5 h-5" />
</button>

    </div>
  </div>
</div>

      </div>
    </section>
  );
};

export default ProgramTimer;
